export default __webpack_public_path__ + "static/media/minisite-pagetype-register_success.de98380c.svg";